import { FormGroup } from '@angular/forms';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-submit-button',
  template: `
  <button type="submit" id="submit" [ngClass]="ngClaz" [disabled]="!form.valid || isProcessing">
    <div *ngIf="isProcessing">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing ...
    </div>
    <span *ngIf="!isProcessing">{{ text }} </span>
  </button>
  `
})
export class SubmitButtonComponent {

  @Input()
  form: FormGroup;

  @Input()
  isProcessing = false;

  @Input()
  text: string;

  @Input()
  ngClaz? = 'btn btn-primary';
}
